export const content = {
  title: 'Your switching information',
}
